import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import { useSelector } from "react-redux";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
function MedicalLabScientistDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [scientistDetails, setScientistDetails] = useState({});
  const pageSlice = useSelector((state) => state.pageSlice.pageSlice);
  const navigate = useNavigate();
  const { state } = useLocation();
  const activeTab = state?.activeTab;
  const fetchScientistDetails = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthProfessional/get-medicalLabScientist/${id}`
      );
      setScientistDetails(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching medical lab scientist details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchScientistDetails();
  }, [id]);

  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleStatusChange = async (status) => {
    if (status === "approved") {
      setIsApproving(true);
    } else {
      setIsRejecting(true);
    }

    try {
      const response = await client.put(
        `/admin/profile/change-status/${id}`,
        null,
        {
          params: { status },
        }
      );

      if (response.data.status) {
        toast.success(
          response.data.message || `Request ${status} successfully`
        );
        fetchScientistDetails();
        navigate(-1);
      } else {
        toast.error(response.data.message || `Failed to ${status} request`);
      }
    } catch (error) {
      console.error(`Error ${status} request:`, error);
      toast.error(`Failed to ${status} request`);
    } finally {
      if (status === "approved") {
        setIsApproving(false);
      } else {
        setIsRejecting(false);
      }
    }
  };

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() =>
                    navigate(-1, { state: { activeTab: activeTab } })
                  }
                />
                <span>Requests</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img
                          src={scientistDetails?.information?.image}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div className="">
                          <h2>
                            {scientistDetails?.user?.firstName}{" "}
                            {scientistDetails?.user?.lastName}
                          </h2>
                          <p>
                            <span>Request ID:</span>{" "}
                            {scientistDetails?.profileId}
                          </p>
                        </div>
                        {pageSlice === "request" && activeTab === "Pending" && (
                          <div className="reject-approve-btn">
                            <button
                              className="reject-btn"
                              onClick={() => handleStatusChange("rejected")}
                              disabled={isRejecting || isApproving}
                            >
                              {isRejecting ? "Processing..." : "Reject"}
                            </button>
                            <button
                              className="approve-btn"
                              onClick={() => handleStatusChange("approved")}
                              disabled={isApproving || isRejecting}
                            >
                              {isApproving ? "Processing..." : "Approve"}
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Henry"
                            value={formatRole(
                              scientistDetails?.facilityOrProfession
                            )}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={formatRole(scientistDetails?.role)}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              scientistDetails?.user?.phoneNumber?.number
                                ? `+${scientistDetails?.user?.phoneNumber?.dialCode} ${scientistDetails?.user?.phoneNumber?.number}`
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={scientistDetails?.user?.email}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={scientistDetails?.information?.address?.add}
                            readOnly
                          />
                        </div>
                        <div className="input-field"></div>
                      </div>
                      <div className="input-group">
                        {scientistDetails?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                scientistDetails?.information?.additionalText
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {scientistDetails?.professionalDetails
                          ?.qualification && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Qualification</label>
                            <textarea
                              placeholder="Qualification"
                              value={
                                scientistDetails?.professionalDetails
                                  ?.qualification
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="request-document">
                <h3>Professional Documents</h3>
                <div className="doc-main">
                  <div>
                    {scientistDetails?.professionalDocuments?.certificate && (
                      <div className="doc">
                        <div
                          className="doc-file"
                          onClick={() =>
                            setSelectedImage(
                              scientistDetails?.professionalDocuments
                                ?.certificate
                            )
                          }
                        >
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={
                              scientistDetails?.professionalDocuments
                                ?.certificate
                            }
                            alt=""
                          />
                        </div>
                        <div className="Document-name">
                          <span>
                            {scientistDetails?.professionalDocuments &&
                            Object.keys(scientistDetails.professionalDocuments)
                              .length > 0
                              ? Object.keys(
                                  scientistDetails.professionalDocuments
                                )[0]
                              : "No document available"}
                          </span>
                        </div>
                      </div>
                    )}
                    {scientistDetails?.professionalDocuments?.license !== "" ? (
                      <div className="doc">
                        <div
                          className="doc-file"
                          onClick={() =>
                            setSelectedImage(
                              scientistDetails?.professionalDocuments?.license
                            )
                          }
                        >
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={
                              scientistDetails?.professionalDocuments?.license
                            }
                            alt=""
                          />
                        </div>
                        <div className="Document-name">
                          <span>
                            {scientistDetails?.professionalDocuments &&
                            Object.keys(scientistDetails.professionalDocuments)
                              .length > 0
                              ? Object.keys(
                                  scientistDetails.professionalDocuments
                                )[1]
                              : "No document available"}
                          </span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              {scientistDetails?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {scientistDetails?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                scientistDetails?.personalDocuments?.nimc
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={scientistDetails?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {scientistDetails?.personalDocuments &&
                              Object.keys(scientistDetails.personalDocuments)
                                .length > 0
                                ? Object.keys(
                                    scientistDetails.personalDocuments
                                  )[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {scientistDetails?.personalDocuments?.license !== "" ? (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                scientistDetails?.personalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={scientistDetails?.personalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {scientistDetails?.personalDocuments &&
                              Object.keys(scientistDetails.personalDocuments)
                                .length > 0
                                ? Object.keys(
                                    scientistDetails.personalDocuments
                                  )[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div class="doctors-details">
                <h3>Schedule</h3>
                <div class="doc-main">
                  <div
                    className="doc d-flex justify-content-between py-0"
                    style={{ width: "550px" }}
                  >
                    {scientistDetails?.serviceAndSchedule?.map(
                      (service, index) => (
                        <table>
                          <thead>
                            <tr className="pb-3">
                              <td className="service-name" colSpan="2">
                                Service Name : {service.name}
                              </td>
                            </tr>
                            <tr>
                              <th>Time</th>
                              <th>Days Available</th>
                            </tr>
                          </thead>

                          <tbody>
                            {service.slots.map((slot, slotIndex) => (
                              <tr key={slotIndex}>
                                <td>
                                  {slot.startTime} - {slot.endTime}
                                </td>
                                <td>{slot.days.join(", ")}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )
                    )}
                  </div>
                </div>
              </div>
              <div class="doctors-details schedule-main">
                <h3>Schedule</h3>
                <div class="doc-main">
                  <div class="doc">
                    <div class="head">
                      <h4>Time</h4>
                    </div>
                    <ul>
                      <li>09:00 - 12:00</li>
                      <li>09:00 - 12:00</li>
                      <li>09:00 - 12:00</li>
                      <li>09:00 - 12:00</li>
                    </ul>
                  </div>
                  <div class="doc day">
                    <div class="head">
                      <h4>Days Available</h4>
                    </div>
                    <ul>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                      <li>
                        09:00 - 12:00 <span>Mon, Tue, Wed, Thu, Fri, Sat</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
}

export default MedicalLabScientistDetail;
